import './TargetGoal.css';
import React, {useState} from "react";

function TargetGoal(props) {
    function getActiveMilestone(index) {
        if (index===props.steps.length) {
            return props.steps.length-1
        }
        if (props.steps[index].endsWith("&")) {
            return getActiveMilestone(index+1)
        } else
        return index
    }

    const [activeMilestone, setActiveMilestone] = useState(() => getActiveMilestone(0))

    function processStep(step) {
        let stepString=step
        if (step.endsWith("&")) {
            stepString = step.slice(0, -1)
        }
        return stepString
    }
    return (
        <div>
            <div className="circleLine"></div>
            <div className="circleRow">
                {props.steps.map((step, index) => (
                    <div onClick={() => setActiveMilestone(index)} key={index}>
                        {activeMilestone === index && 
                            <p onClick={() => props.setShowAddTaskMilestone(step)} className={step.endsWith("&") ? "circleTextActiveCompleted" : "circleTextActive"}> {processStep(step)} </p>
                        }
                        {activeMilestone !== index && 
                        <p className="circleText"> {index+1} </p>
                        }
                    </div>
                ))}
            </div>
        </div>
    )
}

export default TargetGoal;